import type { MintrouteDetailsValues } from '../schemas/mapping.schema';

/** Our names copied into a Mintroute details row. */
export interface MintrouteCatalogueNames {
  category: string | null;
  brand: string | null;
  denomination: string | null;
}

/** Largest integer a JSON number carries exactly; longer EANs stay text, as on the server. */
const MAX_EXACT_DIGITS = 15;

function eanToken(ean: string): number | string {
  const value = ean.trim();
  const numeric = /^[1-9]\d*$/.test(value) && value.length <= MAX_EXACT_DIGITS;
  return numeric ? Number(value) : value;
}

const idOrNull = (value: number) => (Number.isInteger(value) && value > 0 ? value : null);

/**
 * PREVIEW of the details row the server will store (UT system
 * `MintrouteDetails.Build` — the server builds and saves it; this only shows
 * the operator what it will be). Same keys in the same order as the Mintroute
 * catalogue import:
 *
 * [{"Category":"Games","CategoryId":"Games","Brand":"Sawa Jackaroo","BrandId":304,
 *   "Denomination":"220 Diamond","DenominationId":4838,"EAN":3095447348973,
 *   "EAN13":3095447348973,"Wallet":"USD","ContractPrice":2.07,"VAT":"NO",
 *   "Barcode":3095447348973}]
 */
export function buildMintrouteDetailsPreview(
  names: MintrouteCatalogueNames,
  ean: string,
  details: MintrouteDetailsValues,
  cost: number,
): string {
  const code = eanToken(ean);
  const categoryName = details.category.trim(); // as typed, never replaced
  const row = {
    Category: categoryName,
    CategoryId: categoryName,
    Brand: names.brand,
    BrandId: idOrNull(details.brandId),
    Denomination: names.denomination,
    DenominationId: idOrNull(details.denominationId),
    EAN: code,
    EAN13: code,
    Wallet: details.wallet.trim().toUpperCase() || 'USD',
    ContractPrice: Number.isFinite(cost) ? cost : null,
    VAT: details.vat,
    Barcode: code,
  };
  return JSON.stringify([row]);
}
